import { useForm } from "react-hook-form";
import { IUserDto } from "Apis/Models/IUserDto";
import ControlledInput from "Components/Input";
import { useTranslation } from "react-i18next";
import Button from "Components/Button";
import { useMutateUser } from "Apis/UsersApi";
import Space from "Components/Space";
import FlexRow from "Components/FlexRow";
import React, { useEffect } from "react";
import {useAuthProvider} from "Providers/AuthProvider";
import ControlledSelect from "../../../Components/Select/ControlledSelect";
import Select from "../../../Components/Select";
import {useProjects} from "../../../Apis/ProjectApi";
import useFilteredList from "../../../Hooks/UseFilteredList";
import {useCustomers} from "../../../Apis/CustomerApi";

interface IProps {
    user?: IUserDto;
    onSubmit?: (data: IUserDto) => void;
}
const UsersForm = (props: IProps) => {
    
    const { t } = useTranslation();

    const { resetPassword } = useAuthProvider();
    
    const { control, handleSubmit, reset } = useForm<IUserDto>();
    const { mutateAsync, isLoading } = useMutateUser();
    
    const { data: projects } = useProjects({includeAll: true})
    const { data: customers } = useCustomers({includeAll: true});

    const [ filteredPermissions, setPermissionFilter ] = useFilteredList([{name: 'Admin', id: 'Admin'}], x => [x.name]);
    const [ filteredProjects, setProjectsFilter ] = useFilteredList(projects?.items ?? [], x => [x.name]);
    const [ filteredCustomers, setCustomerFilter ] = useFilteredList(customers?.items ?? [], x => [x.name, x.vatNumber]);


    useEffect(() => {
        if (props.user) {
            reset(props.user);
        }
    }, [reset, props.user])
    
    const onSubmit = async(data: IUserDto) => {
        const isNewUser = !data.id;

        await mutateAsync(data);

        if (isNewUser) {
            await resetPassword(data)
        }
        
        if (props.onSubmit) {
            props.onSubmit(data);
        }

        
        reset();
    }
    
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Space direction={"vertical"} size={"large"}>
                <ControlledInput rules={{required: true}} name={"name"} control={control} placeholder={t('name')} />
                <ControlledInput rules={{required: true}} name={"email"} control={control} placeholder={t('email')} />

                <ControlledSelect multiple control={control} placeholder={t('permissions')} name={"permissions"} onFilter={setPermissionFilter}>
                    {filteredPermissions?.map(x => <Select.Option key={x.id} label={x.name} value={x.id}/>)}
                </ControlledSelect>

                <ControlledSelect multiple control={control} placeholder={t('allowedSettlements')} name={`settlementProjects`} onFilter={filteredProjects => setProjectsFilter(filteredProjects)}>
                    {filteredProjects?.map(x => <Select.Option key={x.id} label={x.name} value={x.id}/>)}
                </ControlledSelect>

                <ControlledSelect control={control} placeholder={t('customer')} name={"customerId"} onFilter={setCustomerFilter}>
                    {filteredCustomers?.map(x => <Select.Option key={x.id} label={x.name} value={x.id} />)}
                </ControlledSelect>
                
                <FlexRow justify={"end"}>
                    <Button buttonType={"submit"} type={"primary"} text={t('save')} loading={isLoading} />
                </FlexRow>
            </Space>
        </form>
    )
}

export default UsersForm
